<aside
  aria-label="ZIP archive"
  id="archive-panel"
  part="archive-panel">
  <header
    class="archive-heading"
    part="archive-heading">
    <strong
      id="archive-name"
      part="archive-title"
      [title]="name()"
      >{{ name() }}</strong
    >
    @if (size() !== null) {
      <small
        id="archive-size"
        part="archive-meta"
        [title]="formattedSize()"
        >Size: {{ formattedSize() }}</small
      >
    }
  </header>
  @if (info() === 'Reading ZIP catalog…') {
    <p
      class="archive-message"
      role="status">
      Reading ZIP catalog…
    </p>
  }
  @if (error()) {
    <p
      class="archive-message"
      role="alert">
      {{ error() }}
    </p>
  }
  <nav
    #tree
    aria-label="Archive files"
    id="archive-tree"
    part="archive-tree"></nav>
</aside>
